import { useMemo } from "react";

import PropTypes from "prop-types";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";
import "quill/dist/quill.snow.css";
import "quill-mention/dist/quill.mention.css";

const QuillInput = ({ value }) => {
  const navigate = useNavigate();

  const sanitized = useMemo(
    () =>
      DOMPurify.sanitize(value ?? "", {
        ADD_ATTR: [
          "contenteditable",
          "data-id",
          "data-value",
          "data-denotation-char",
          "data-index",
          "data-link",
        ],
      }),
    [value],
  );

  const handleClick = (e) => {
    const mention = e.target.closest(".mention");
    if (!mention) return;
    const userId = mention.dataset.id;
    const denotation = mention.dataset.denotationChar;
    if (denotation === "@" && userId) {
      e.preventDefault();
      navigate(`/users/${userId}`);
    }
  };

  return (
    <div className="ql-snow quill-read-only" onClick={handleClick}>
      <div
        className="ql-editor"
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    </div>
  );
};

QuillInput.propTypes = {
  value: PropTypes.string.isRequired,
};

export default QuillInput;
